import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, OutlinedInput, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AreaOfInterest, baseURL, Climates, Education, Grades, Health, LearningTech, MathCourses, Participations, PhysicsCourses, Political, ProjectTypes, Skills, socialOptions, Subjects, SupportTypes, TeamWork, Technology, Tests, WorkingHours } from '../common/const';
import { showNotification } from '../common/Notification/ToastifyNotification';
import { postDataRequest } from '../common/commonfunction';
import { EditStudent, EditUser, RegisterStudent, SchoolDataByUserId, Signup, UserById } from '../common/api';
import { LoadingPage } from '../common/LoadingPage';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const NewGrid = styled(Grid)(({ theme }) => ({
  marginTop: 1,
  width: '50%',
  margin: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    margin: 0
  },
}));

const Typo = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontSize: 14,
  fontWeight: 600,
}));

const NewBox = styled(Box)(({ theme }) => ({
  display: 'flex'
}));

const SignUpBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const RadioLabel = styled(FormControlLabel)(({ theme }) => ({
  color: 'black',
  fontSize: 14,
}));

const SignUp = ({
  fromTutoring,
  fromTestPrep
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const page = searchParams.get('page');
  const [disabled, setDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isDemoOpen, setDemoOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [grade, setGrade] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [subject, setSubject] = useState('');
  const [test, setTest] = useState('');
  const [mathCourses, setMathCourses] = useState('');
  const [physicsCourses, setPgysicsCourses] = useState('');
  const [areaOfInterest, setAreaOfInterest] = useState([]);
  const [participation, setParticipation] = useState([]);
  const [supportType, setSupportType] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [social, setSocial] = useState([]);
  const [climate, setClimate] = useState([]);
  const [political, setPolitical] = useState([]);
  const [health, setHealth] = useState([]);
  const [technology, setTechnology] = useState([]);
  const [education, setEducation] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [thanksOpen, setThanks] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = React.useState(false);
  const [userId, setUserId] = useState(null);
  const [fullSchoolData, setFullSchoolData] = useState(null);
  useEffect(() => {
    if (id) {
      setDataLoading(true);
      postDataRequest(`${baseURL}/user/${id}`, {
        query: UserById,
        variables: {
          userid: id,
        },
      }).then((resp) => {
        if (resp?.errors && resp?.errors[0]?.message) {
          showNotification(resp?.errors[0]?.message, 'error');
        } else {
          if (resp?.data.userById) {
            const { firstname, lastname, email, phonenumber } = resp?.data.userById;
            setFirstName(firstname);
            setLastName(lastname);
            setEmail(email);
            setPhoneNumber(phonenumber);
            postDataRequest(`${baseURL}/school/${id}`, {
              query: SchoolDataByUserId,
              variables: {
                userid: id,
              },
            }).then((resp) => {
              if (resp?.errors && resp?.errors[0]?.message) {
                showNotification(resp?.errors[0]?.message, 'error');
              } else {
                if (resp?.data.schoolDataByUserId) {
                  setResData(resp?.data.schoolDataByUserId);
                  const { schoolname, grade, subject, formdata, test, math_course, physics_course } = resp?.data.schoolDataByUserId;
                  const data = JSON.parse(formdata);
                  setSchoolName(schoolname);
                  setGrade(grade);
                  setSubject(subject);
                  setTest(test);
                  setMathCourses(math_course);
                  setPgysicsCourses(physics_course);
                  setDataArr(data || []);
                  setAreaOfInterest(data?.find((a) => a.areaInterest).areaInterest || []);
                  setSocial(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.socialInterest)?.socialInterest || []);
                  setClimate(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.climateInterest)?.climateInterest || []);
                  setPolitical(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.politicalInterest)?.politicalInterest || []);
                  setHealth(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.heathInterest)?.heathInterest || []);
                  setTechnology(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.techInterest)?.techInterest || []);
                  setEducation(data?.find((a) => a.areaInterest).areaInterest?.find((a) => a.eduInterest)?.eduInterest || []);
                  setProjectType(data?.find((a) => a.projecttype).projecttype || []);
                  setSupportType(data?.find((a) => a.supporttype).supporttype || []);
                  setParticipation(data?.find((a) => a.participation).participation || []);
                  setFullSchoolData(resp?.data.schoolDataByUserId);
                }
              }
              setDataLoading(false);
            }).catch((err) => {
              showNotification(err?.response?.data?.message, 'error');
              setDataLoading(false);
            });
          }
        }
        setDataLoading(false);
      }).catch((err) => {
        showNotification(err?.response?.data?.message, 'error');
        setDataLoading(false);
      });
      setDisabled(true);
    } else {
      setDisabled(false);
      setErrors({});
      setFirstName('');
      setLastName('');
      setSchoolName('');
      setGrade('');
      setEmail('');
      setPhoneNumber('');
      setPassword('');
      setConfirmPassword('');
      setSubject('');
      setTest('');
      setAreaOfInterest([]);
      setParticipation([]);
      setSupportType([]);
      setProjectType([]);
      setSocial([]);
      setClimate([]);
      setPolitical([]);
      setHealth([]);
      setTechnology([]);
      setEducation([]);
      setActiveTab(0);
    }

    if (fromTutoring) {
      setDisabled(false);
      setActiveTab(0);
    }
    if (fromTestPrep) {
      setDisabled(false);
      setActiveTab(0);
    }
  }, [id, fromTutoring, fromTestPrep]);

  const handleSignUp = async () => {
    const errors = {};
    if (!firstName) {
      errors.firstname = 'First Name is required';
    }
    if (!lastName) {
      errors.lastname = 'Last Name is required';
    }
    if (!schoolName) {
      errors.schoolname = 'School Name is required';
    }
    if (!grade) {
      errors.grade = 'Please select a grade';
    }
    if (!password && !id) {
      errors.password = 'Password is required';
    }
    if (!confirmPassword && !id) {
      errors.confirmPassword = 'Confirm Password is required';
    }
    if (!email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid';
    }

    if (!phoneNumber) {
      errors.phoneNumber = 'Phone number is required';
    }
    if (!!fullSchoolData?.subject && !subject && id) {
      errors.subject = 'Please select subject';
    }
    if (!!fullSchoolData?.test && !test && id) {
      errors.subject = 'Please select test';
    }
    if (!!fullSchoolData?.math_course && !mathCourses && id) {
      errors.mathCourse = 'Please select math course';
    }
    if (!!fullSchoolData?.physics_course && !physicsCourses && id) {
      errors.mathCourse = 'Please select physics course';
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      setErrors({});
      setDataLoading(true);
      if (id) {
        await postDataRequest(`${baseURL}/user/edit/${id}`, {
          query: EditUser,
          variables: {
            firstname: firstName,
            lastname: lastName,
            phonenumber: phoneNumber,
            userid: id
          },
        }).then(async (res) => {
          if (res?.errors && res?.errors[0]?.message) {
            showNotification(res?.errors[0]?.message, 'error');
            setDataLoading(false);
          } else {
            if (res?.data.editUser) {
              console.log('/school/edit');
              console.log({
                variables: {
                  schoolname: schoolName,
                  grade: Number(grade),
                  subject: Number(subject),
                  math_course: Number(mathCourses),
                  physics_course: Number(physicsCourses),
                  test: Number(test),
                  userid: id,
                  schoolid: resData?.schoolid
                }
              });


              await postDataRequest(`${baseURL}/school/edit/${resData?.schoolid}`, {
                query: EditStudent,
                variables: {
                  schoolname: schoolName,
                  grade: Number(grade),
                  subject: Number(subject),
                  test: Number(test),
                  math_course: Number(mathCourses),
                  physics_course: Number(physicsCourses),
                  userid: id,
                  schoolid: resData?.schoolid
                },
              }).then((resp) => {
                if (resp?.errors && resp?.errors[0]?.message) {
                  showNotification(resp?.errors[0]?.message, 'error');
                } else {
                  if (resp?.data.editStudent) {
                    setFirstName('');
                    setLastName('');
                    setSchoolName('');
                    setGrade('');
                    setEmail('');
                    setPhoneNumber('');
                    setPassword('');
                    setConfirmPassword('');
                    setActiveTab(1);
                    window.scrollTo(0, 0);
                  }
                }
                setDataLoading(false);
              }).catch((err) => {
                showNotification(err?.response?.data?.message, 'error');
                setDataLoading(false);
              });
            }
          }
        }).catch((err) => {
          showNotification(err?.response?.data?.message, 'error');
          setDataLoading(false);
        });
      } else {
        await postDataRequest(baseURL + '/user/signup', {
          query: Signup,
          variables: {
            firstname: firstName,
            lastname: lastName,
            email: email,
            phonenumber: phoneNumber,
            password: password
          },
        }).then(async (res) => {
          if (res?.errors && res?.errors[0]?.message) {
            showNotification(res?.errors[0]?.message, 'error');
            setDataLoading(false);
          } else {
            if (res?.data.signUp?.userid) {
              setUserId(res?.data.signUp?.userid);
              await postDataRequest(`${baseURL}/school/register`, {
                query: RegisterStudent,
                variables: {
                  schoolname: schoolName,
                  grade: Number(grade),
                  userid: res?.data.signUp?.userid
                },
              }).then((resp) => {
                if (resp?.errors && resp?.errors[0]?.message) {
                  showNotification(resp?.errors[0]?.message, 'error');
                } else {
                  if (resp?.data.registerStudent?.schoolid) {
                    setResData(resp?.data.registerStudent);
                    setFirstName('');
                    setLastName('');
                    setSchoolName('');
                    setGrade('');
                    setEmail('');
                    setPhoneNumber('');
                    setPassword('');
                    setConfirmPassword('');
                    setActiveTab(1);
                    window.scrollTo(0, 0);
                  }
                }
                setDataLoading(false);
              }).catch((err) => {
                showNotification(err?.response?.data?.message, 'error');
                setDataLoading(false);
              });
            }
          }
        }).catch((err) => {
          showNotification(err?.response?.data?.message, 'error');
          setDataLoading(false);
        });
      }
    }
  }
  const handleBootcampSubmit = async () => {
    const errors = {};
    if (!firstName) {
      errors.firstname = 'First Name is required';
    }
    if (!lastName) {
      errors.lastname = 'Last Name is required';
    }
    if (!schoolName) {
      errors.schoolname = 'School Name is required';
    }
    if (!grade) {
      errors.grade = 'Please select a grade';
    }
    if (!email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid';
    }

    if (!phoneNumber) {
      errors.phoneNumber = 'Phone number is required';
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      const resp = await postDataRequest(`${baseURL}/user/register-bootcamp`, {
        query: 'registerBootcamp',
        variables: {
          firstname: firstName,
          lastname: lastName,
          email: email,
          phonenumber: phoneNumber,
          schoolname: schoolName,
          grade: Grades.find((g) => g.value === grade)?.name,
        },
      });
      if (resp?.errors && resp?.errors[0]?.message) {
        showNotification(resp?.errors[0]?.message, 'error');
      } else {
        showNotification('Registration successful, Our team will contact you soon', 'success');
        setFirstName('');
        setLastName('');
        setSchoolName('');
        setGrade('');
        setEmail('');
        setPhoneNumber('');
        
      }
    }
  }

  const updateSignUp = async () => {
    const errors = {};
    if (dataArr.length === 0) {
      errors.areaOfInterest = 'Please select atleast one option';
      errors.projecttype = 'Please select atleast one option';
      errors.supporttype = 'Please select atleast one option';
      errors.workinghour = 'Please select option';
      errors.learning = 'Please select option';
      errors.teamWork = 'Please select option';
      errors.participation = 'Please select atleast one option';
    } else {
      if (dataArr?.find((d) => d.areaInterest)?.areaInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest) {
        errors.areaOfInterest = 'Please select atleast one option';
      } else {
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '1')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest) {
            errors.socialInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest.find((a) => a === '6')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest.find((a) => a.others)) {
                errors.socialInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '2')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest) {
            errors.climateInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest.find((a) => a === '6')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest.find((a) => a.others)) {
                errors.climateInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '3')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest) {
            errors.politicalInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest.find((a) => a === '6')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest.find((a) => a.others)) {
                errors.politicalInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '5')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest) {
            errors.heathInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest.find((a) => a === '5')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest.find((a) => a.others)) {
                errors.heathInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '6')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest) {
            errors.techInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest.find((a) => a === '6')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest.find((a) => a.others)) {
                errors.heathInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '7')) {
          if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest?.length === 0 || !dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest) {
            errors.eduInterest = 'Please select atleast one option';
          } else {
            if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest.find((a) => a === '5')) {
              if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest.find((a) => a.others)) {
                errors.eduInterest = 'Please enter specific text';
              }
            }
          }
        }
        if (dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a === '8')) {
          if (!dataArr?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.others)) {
            errors.areaOfInterest = 'Please enter specific cause interest';
          }
        }
      }
      if (dataArr?.find((d) => d.projecttype)?.projecttype?.length === 0 || !dataArr?.find((d) => d.projecttype)?.projecttype) {
        errors.projecttype = 'Please select atleast one option';
      } else {
        if (dataArr?.find((d) => d.projecttype)?.projecttype.find((a) => a === '11')) {
          if (!dataArr?.find((d) => d.projecttype)?.projecttype.find((a) => a.others)) {
            errors.projecttype = 'Please enter specific type of project';
          }
        }
      }
      if (dataArr?.find((d) => d.supporttype)?.supporttype?.length === 0 || !dataArr?.find((d) => d.supporttype)?.supporttype) {
        errors.supporttype = 'Please select atleast one option';
      } else {
        if (dataArr?.find((d) => d.supporttype)?.supporttype.find((a) => a === '7')) {
          if (!dataArr?.find((d) => d.supporttype)?.supporttype.find((a) => a.others)) {
            errors.supporttype = 'Please enter specific type of support';
          }
        }
      }
      if (!dataArr?.find((d) => d.workinghour)?.workinghour) {
        errors.workinghour = 'Please select option';
      }
      if (!dataArr?.find((d) => d.learning)?.learning) {
        errors.learning = 'Please select option';
      }
      if (!dataArr?.find((d) => d.teamWork)?.teamWork) {
        errors.teamWork = 'Please select option';
      }
      if (dataArr?.find((d) => d.participation)?.participation?.length === 0 || !dataArr?.find((d) => d.participation)?.participation) {
        errors.participation = 'Please select atleast one option';
      } else {
        if (dataArr?.find((d) => d.participation)?.participation.find((a) => a === '6')) {
          if (!dataArr?.find((d) => d.participation)?.participation.find((a) => a.others)) {
            errors.participation = 'Please enter specific text';
          }
        }
      }
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      await postDataRequest(`${baseURL}/school/edit/${resData?.schoolid}`, {
        query: EditStudent,
        variables: {
          schoolid: resData?.schoolid,
          formdata: JSON.stringify(dataArr),
          userid: resData?.userid
        },
      }).then((resp) => {
        if (resp?.errors && resp?.errors[0]?.message) {
          showNotification(resp?.errors[0]?.message, 'error');
        } else {
          if (resp?.data.editStudent) {
            setDemoOpen(true);
          }
        }
        setDataLoading(false);
      }).catch((err) => {
        showNotification(err?.response?.data?.message, 'error');
        setDataLoading(false);
      });
    }
  }

  const handleTutoringSubmit = async () => {
    const errors = {};
    if (!firstName) {
      errors.firstname = 'First Name is required';
    }
    if (!lastName) {
      errors.lastname = 'Last Name is required';
    }
    if (!schoolName) {
      errors.schoolname = 'School Name is required';
    }
    if (!grade) {
      errors.grade = 'Please select a grade';
    }
    if (!password && !id) {
      errors.password = 'Password is required';
    }
    if (!confirmPassword && !id) {
      errors.confirmPassword = 'Confirm Password is required';
    }
    if (fromTutoring && !subject) {
      errors.subject = 'Please select subject';
    }
    if (fromTestPrep && !test) {
      errors.test = 'Please select test';
    }

    // if(fromTutoring && !mathCourses) {
    //   errors.mathCourse = 'Please select math course';
    // }
    // if(fromTutoring && !physicsCourses) {
    //   errors.physicsCourse = 'Please select physics course';
    // }

    if (!phoneNumber) {
      errors.phoneNumber = 'Phone number is required';
    }

    if (!email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid';
    }
    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      setErrors({});
      setDataLoading(true);
      if (id) {
        await postDataRequest(`${baseURL}/school/edit/${resData?.schoolid}`, {
          query: EditStudent,
          variables: {
            schoolid: resData?.schoolid,
            formdata: JSON.stringify(dataArr),
            userid: id,
            subject: Number(subject),
            test: Number(test),
            math_course: Number(mathCourses),
            physics_course: Number(physicsCourses)
          },
        }).then((resp) => {
          if (resp?.errors && resp?.errors[0]?.message) {
            showNotification(resp?.errors[0]?.message, 'error');
          } else {
            if (resp?.data.editStudent) {
              setDemoOpen(true);
            }
          }
          setDataLoading(false);
        }).catch((err) => {
          showNotification(err?.response?.data?.message, 'error');
          setDataLoading(false);
        });
      } else {
        await postDataRequest(baseURL + '/user/signup', {
          query: Signup,
          variables: {
            firstname: firstName,
            lastname: lastName,
            email: email,
            phonenumber: phoneNumber,
            password: password
          },
        }).then(async (res) => {
          if (res?.errors && res?.errors[0]?.message) {
            showNotification(res?.errors[0]?.message, 'error');
            setDataLoading(false);
          } else {
            if (res?.data.signUp?.userid) {
              setUserId(res?.data.signUp?.userid);
              await postDataRequest(`${baseURL}/school/register`, {
                query: RegisterStudent,
                variables: {
                  schoolname: schoolName,
                  grade: Number(grade),
                  subject: Number(subject),
                  test: Number(test),
                  math_course: Number(mathCourses),
                  physics_course: Number(physicsCourses),
                  userid: res?.data.signUp?.userid
                },
              }).then((resp) => {
                if (resp?.errors && resp?.errors[0]?.message) {
                  showNotification(resp?.errors[0]?.message, 'error');
                } else {
                  if (resp?.data.registerStudent?.schoolid) {
                    setFirstName('');
                    setLastName('');
                    setSchoolName('');
                    setGrade('');
                    setEmail('');
                    setPhoneNumber('');
                    setPassword('');
                    setConfirmPassword('');
                    setSubject('');
                    setTest('');
                    setDemoOpen(true);
                  }
                }
                setDataLoading(false);
              }).catch((err) => {
                showNotification(err?.response?.data?.message, 'error');
                setDataLoading(false);
              });
            }
          }
        }).catch((err) => {
          showNotification(err?.response?.data?.message, 'error');
          setDataLoading(false);
        });
      }
    }
  }

  return (
    <>
      <div className='page_container'>
        <section >
          {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
          <Dialog open={thanksOpen} maxWidth="sm">
            <DialogTitle>Thank You for Registering!</DialogTitle>
            <DialogContent>
              <Typography variant="body1" paragraph>
                Congratulations for sign up and showing your interest on Dream College Path Demo
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                size="Medium"
                variant="contained"
                style={{ width: 80, backgroundColor: '#FDB515' }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  setActiveTab(0);
                  navigate(`/edit/?id=${userId || id}`);
                  window.location.reload();
                  setThanks(false);
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={confirmOpen} maxWidth="sm">
            <DialogTitle>Confirm Your Choice</DialogTitle>
            <DialogContent>
              <Typography variant="body1" paragraph>
                Are you sure you don't need a demo session at this moment? We highly recommend scheduling
                a demo to get the most out of our platform, but if you're ready to proceed, we understand.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                size="Medium"
                variant="contained"
                style={{ width: 150, backgroundColor: '#FDB515' }}
                onClick={() => {
                  setDemoOpen(true);
                  setConfirmOpen(false);
                }}
              >
                No, I need it
              </Button>
              <Button
                size="Medium"
                variant="contained"
                style={{ width: 150, backgroundColor: '#003262' }}
                onClick={() => {
                  setConfirmOpen(false);
                  setThanks(true);
                }}
              >
                Yes, proceed
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={isDemoOpen} maxWidth="sm">
            <DialogTitle>Schedule a Demo</DialogTitle>
            <DialogContent>
              <Typography variant="body1" paragraph>
                We would love to show you how our platform works and how it can benefit you.
                Scheduling a demo is quick and easy. Would you like to schedule a demo with us?
              </Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                If you're ready, you can book a time with just a few clicks. If you prefer to wait,
                feel free to come back later.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                size="Medium"
                variant="contained"
                style={{ width: 150, backgroundColor: '#FDB515' }}
                onClick={() => {
                  setDemoOpen(false);
                  setConfirmOpen(true);
                }}
              >
                No, Thanks
              </Button>
              <Button
                size="Medium"
                variant="contained"
                style={{ width: 150, backgroundColor: '#003262' }}
                onClick={() => {
                  setThanks(true);
                  setDemoOpen(false);
                  window.open("https://calendly.com/dreamcollegepath/30min", "_blank");
                }}
              >
                Yes, Schedule
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={isOpen}
            maxWidth="sm"
          >
            <DialogTitle>Profile Info</DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>Email ID</Typo>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={email}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl size="small" fullWidth variant="standard">
                    <Typo variant='body1'>Password <span style={{ color: 'red' }}>*</span></Typo>
                    <OutlinedInput
                      id="standard-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        const newErrors = errors;
                        if (!e.target.value) {
                          newErrors.password = 'Password is required';
                        } else {
                          newErrors.password = '';
                        }
                        setErrors(newErrors);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showPassword ? 'hide the password' : 'display the password'
                            }
                            onClick={() => setShowPassword((show) => !show)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.password}</Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl size="small" fullWidth variant="standard">
                    <Typo variant='body1'>Confirm Password <span style={{ color: 'red' }}>*</span></Typo>
                    <OutlinedInput
                      id="standard-adornment-password"
                      type={confirmShowPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        const newErrors = errors;
                        if (!e.target.value) {
                          newErrors.confirmPassword = 'Confirm is required';
                        } else if (password !== e.target.value) {
                          newErrors.confirmPassword = 'Password and confirm Password is mismatch';
                        } else {
                          newErrors.confirmPassword = '';
                        }
                        setErrors(newErrors);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              confirmShowPassword ? 'hide the password' : 'display the password'
                            }
                            onClick={() => setConfirmShowPassword((show) => !show)}
                            edge="end"
                          >
                            {confirmShowPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.confirmPassword}</Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                size="Medium"
                variant="contained"
                color="secondary"
                style={{ backgroundColor: '#FDB515' }}
                onClick={() => {
                  setIsOpen(false);
                }}
                startIcon={<CloseOutlinedIcon style={{ fontSize: 18 }} />}
              >
                Close
              </Button>
              <Button
                size="Medium"
                variant="contained"
                style={{ backgroundColor: '#003262' }}
                onClick={async () => {
                  const errors = {};
                  if (!password) {
                    errors.password = 'Password is required';
                  }
                  if (!confirmPassword) {
                    errors.confirmPassword = 'Confirm Password is required';
                  }
                  setErrors(errors);
                  if (Object.keys(errors).length === 0) {
                    setDataLoading(true);
                    await postDataRequest(`${baseURL}/user/reset-password/${id}`, {
                      query: EditUser,
                      variables: {
                        userid: id,
                        password
                      },
                    }).then((resp) => {
                      if (resp?.errors && resp?.errors[0]?.message) {
                        showNotification(resp?.errors[0]?.message, 'error');
                      } else {
                        setIsOpen(false);
                        showNotification('Password changed successfully', 'success');
                      }
                      setDataLoading(false);
                    }).catch((err) => {
                      showNotification(err?.response?.data?.message, 'error');
                      setDataLoading(false);
                    });
                  }
                }}
                startIcon={<SaveAsOutlinedIcon style={{ fontSize: 18 }} />}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
          {fromTutoring ? (
            <>
              <h2>Tutoring Service</h2>
              <p>
                At Dream College Path, we provide personalized tutoring services designed to help students thrive in their academic pursuits. Currently, we specialize in computer science and data science, covering both foundational topics such as data structures, algorithms, and databases, as well as advanced concepts integral to success in competitive academic programs and future careers. Whether students are preparing for advanced coursework, entrance exams, or aiming to build a strong foundation, our services are tailored to address individual needs and goals.
              </p>
              <p>
                Our tutors are experienced educators and professionals committed to delivering high-quality, personalized instruction. Each session is thoughtfully customized to align with a student’s learning style and objectives, bridging gaps in understanding and enhancing mastery of challenging concepts. By focusing on clarity, comprehension, and skill-building, we empower students to approach complex subjects with confidence and poise, paving the way for success in competitive academic environments.
              </p>
              <p>
                While our primary focus is on computer science and data science, we are excited to expand into other disciplines in the near future. At Dream College Path, we are dedicated to unlocking every student’s potential and guiding them toward academic success and beyond.
              </p>
            </>
          ) : fromTestPrep ? (
            <>
              <h2>SAT and ACT Test Preparation</h2>
              <p>
                Preparing for the SAT or ACT can be a daunting task, but with the right guidance, you can achieve your best score. At Dream College Path, we understand the importance of these tests in your college admissions journey. Our Test Prep services are designed to help you maximize your potential and reach your goals.          </p>
              <p>
                At Dream College Path, we believe in a holistic approach to test prep. We don’t just teach you the material; we teach you how to think critically, manage your time effectively, and approach each question with confidence. Our comprehensive curriculum covers all sections of the SAT and ACT, including math, reading, writing, and science. We also provide practice tests and detailed feedback to track your progress and adjust your learning plan as needed.          </p>
              <p>
                Ready to take the next step toward your dream college? Sign up for a free consultation today and discover how our Test Prep services can help you achieve your goals.
              </p>
            </>
          ) : (
            <>
              {id ? (
                <SignUpBox>
                  <Box>
                    <h2>Student Enrollment Form</h2>
                  </Box>
                  <Box class="profile">
                    <Button
                      size="Medium"
                      variant="contained"
                      style={{ marginRight: 10, backgroundColor: '#003262' }}
                      onClick={() => {
                        setDisabled(!disabled);
                        setActiveTab(0);
                      }}
                      startIcon={disabled ? <EditOutlinedIcon style={{ fontSize: 18 }} /> : <VisibilityRoundedIcon style={{ fontSize: 18 }} />}
                    >
                      {disabled ? 'Edit' : 'View'}
                    </Button>
                    <Button
                      size="Medium"
                      variant="contained"
                      style={{ backgroundColor: '#003262' }}
                      onClick={() => {
                        setIsOpen(true);
                      }}
                      startIcon={<AccountCircleOutlinedIcon style={{ fontSize: 18 }} />}
                    >
                      Profile
                    </Button>
                  </Box>
                </SignUpBox>
              ) : (
                <>
                  {page === 'bootcamp' ? (
                    <h2>Student Enrollment</h2>
                  ) : (
                    <h2>Sign-Up & Student Enrollment</h2>
                  )}
                </>
              )}
              {!id && (

                <p>
                  {page === 'bootcamp' ? (
                    <span>
                      Join Decode Life: A Computational Biology Bootcamp for Future Scientists by signing up and filling out our student enrollment form.
                    </span>
                  ) : (
                    <span>
                      Join Dream College Path by signing up and filling out our student enrollment form. Provide your personal details, areas of interest, and college wish list to get started.
                    </span>
                  )}
                </p>
              )}
            </>
          )
          }
          <Divider />
          {
            activeTab === 0 ? (
              <NewGrid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>First Name <span style={{ color: 'red' }}>*</span></Typo>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    disabled={disabled}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      const newErrors = errors;
                      if (e.target.value) {
                        newErrors.firstname = '';
                      } else {
                        newErrors.firstname = 'First Name is required';
                      }
                      setErrors(newErrors);
                    }}
                    value={firstName}
                  />
                  <Typography variant='body2' style={{ color: 'red' }}>{errors.firstname}</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>Last Name <span style={{ color: 'red' }}>*</span></Typo>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    disabled={disabled}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      const newErrors = errors;
                      if (e.target.value) {
                        newErrors.lastname = '';
                      } else {
                        newErrors.lastname = 'Last Name is required';
                      }
                      setErrors(newErrors);
                    }}
                    value={lastName}
                  />
                  <Typography variant='body2' style={{ color: 'red' }}>{errors.lastname}</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>School Name <span style={{ color: 'red' }}>*</span></Typo>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    disabled={disabled}
                    onChange={(e) => {
                      setSchoolName(e.target.value);
                      const newErrors = errors;
                      if (e.target.value) {
                        newErrors.schoolname = '';
                      } else {
                        newErrors.schoolname = 'School Name is required';
                      }
                      setErrors(newErrors);
                    }}
                    value={schoolName}
                  />
                  <Typography variant='body2' style={{ color: 'red' }}>{errors.schoolname}</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>Grade Level <span style={{ color: 'red' }}>*</span></Typo>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={grade}
                      onChange={(e) => {
                        setGrade(e.target.value);
                        const newErrors = errors;
                        if (e.target.value) {
                          newErrors.grade = '';
                        } else {
                          newErrors.grade = 'Please select a grade';
                        }
                        setErrors(newErrors);
                      }}
                    >
                      {Grades.map((g) => (
                        <RadioLabel value={g.value} control={<Radio disabled={disabled} />} label={g.name} />
                      ))}
                    </RadioGroup>
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.grade}</Typography>
                  </FormControl>
                </Grid>
                {!id && (
                  <Grid item xs={12} sm={12} md={12}>
                    <Typo variant='body1'>Email ID <span style={{ color: 'red' }}>*</span></Typo>
                    <TextField
                      variant="outlined"
                      type="text"
                      fullWidth
                      size="small"
                      value={email}
                      onChange={(e) => {
                        const newErrors = errors;
                        setEmail(e.target.value);
                        if (!e.target.value) {
                          newErrors.email = 'Email is required';
                        } else if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                          newErrors.email = 'Email is invalid';
                        } else {
                          newErrors.email = '';
                        }
                        setErrors(newErrors);
                      }}
                    />
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>Phone Number <span style={{ color: 'red' }}>*</span></Typo>
                  <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    size="small"
                    value={phoneNumber}
                    disabled={disabled}
                    onKeyDown={(event) => {
                      if (event.keyCode === 38 || event.keyCode === 40) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const newErrors = errors;
                      setPhoneNumber(e.target.value);
                      if (e.target.value?.length >= 10) {
                        newErrors.phoneNumber = '';
                      } else if (!e.target.value) {
                        newErrors.phoneNumber = 'Phone number is required';
                      } else {
                        newErrors.phoneNumber = 'Please provide valid phone number';
                      }
                      setErrors(newErrors);
                    }}
                  />
                  <Typography variant='body2' style={{ color: 'red' }}>{errors.phoneNumber}</Typography>
                </Grid>
                {!id && page !== 'bootcamp' && (
                  <>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl size="small" fullWidth variant="standard">
                        <Typo variant='body1'>Password <span style={{ color: 'red' }}>*</span></Typo>
                        <OutlinedInput
                          id="standard-adornment-password"
                          type={showPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            const newErrors = errors;
                            if (!e.target.value) {
                              newErrors.password = 'Password is required';
                            } else {
                              newErrors.password = '';
                            }
                            setErrors(newErrors);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={() => setShowPassword((show) => !show)}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.password}</Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl size="small" fullWidth variant="standard">
                        <Typo variant='body1'>Confirm Password <span style={{ color: 'red' }}>*</span></Typo>
                        <OutlinedInput
                          id="standard-adornment-password"
                          type={confirmShowPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            const newErrors = errors;
                            if (!e.target.value) {
                              newErrors.confirmPassword = 'Confirm is required';
                            } else if (password !== e.target.value) {
                              newErrors.confirmPassword = 'Password and confirm Password is mismatch';
                            } else {
                              newErrors.confirmPassword = '';
                            }
                            setErrors(newErrors);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  confirmShowPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={() => setConfirmShowPassword((show) => !show)}
                                edge="end"
                              >
                                {confirmShowPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.confirmPassword}</Typography>
                      </FormControl>
                    </Grid>
                  </>
                )}
                {(fromTutoring || (id && !!subject)) && (
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl>
                      <Typo variant='body1'>Which of the following subject interest you the most?
                        {!id && (<span style={{ color: 'red' }}>*</span>)}</Typo>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value);
                          const newErrors = errors;
                          if (e.target.value) {
                            newErrors.subject = '';
                          } else {
                            newErrors.subject = 'Please select subject';
                          }
                          setErrors(newErrors);
                        }}
                      >
                        {Subjects.map((g) => (
                          <RadioLabel value={g.value} control={<Radio disabled={disabled} />} label={g.name} />
                        ))}
                      </RadioGroup>
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.subject}</Typography>
                    </FormControl>
                  </Grid>
                )}
                {(fromTutoring || (id && !!physicsCourses) || (id && !!mathCourses)) && (
                  <Grid item xs={12} sm={12} md={12} className='ap-courses'>
                    {(fromTutoring || (id && !!physicsCourses)) &&
                      <FormControl>
                        <Typo variant='body1'>AP Physics Courses:
                          {!id && (<span style={{ color: 'red' }}>*</span>)}</Typo>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          value={physicsCourses}
                          onChange={(e) => {
                            setPgysicsCourses(e.target.value);
                            const newErrors = errors;
                            if (e.target.value) {
                              newErrors.physicsCourse = '';
                            } else {
                              newErrors.physicsCourse = 'Please select Physics Course';
                            }
                            setErrors(newErrors);
                          }}
                        >
                          {PhysicsCourses.map((g) => (
                            <RadioLabel value={g.value} control={<Radio disabled={disabled} />} label={g.name} />
                          ))}
                        </RadioGroup>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.physicsCourse}</Typography>
                      </FormControl>
                    }
                    {(fromTutoring || (id && !!mathCourses)) &&
                      <FormControl>
                        <Typo variant='body1'>AP Math Courses:
                          {!id && (<span style={{ color: 'red' }}>*</span>)}</Typo>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          value={mathCourses}
                          onChange={(e) => {
                            setMathCourses(e.target.value);
                            const newErrors = errors;
                            if (e.target.value) {
                              newErrors.mathCourse = '';
                            } else {
                              newErrors.mathCourse = 'Please select Math Course';
                            }
                            setErrors(newErrors);
                          }}
                        >
                          {MathCourses.map((g) => (
                            <RadioLabel value={g.value} control={<Radio disabled={disabled} />} label={g.name} />
                          ))}
                        </RadioGroup>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.mathCourse}</Typography>
                      </FormControl>
                    }
                  </Grid>
                )}
                {(fromTestPrep || (id && !!test)) && (
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl>
                      <Typo variant='body1'>Which of the following test interest you the most?
                        {!id && (<span style={{ color: 'red' }}>*</span>)}</Typo>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={test}
                        onChange={(e) => {
                          setTest(e.target.value);
                          const newErrors = errors;
                          if (e.target.value) {
                            newErrors.test = '';
                          } else {
                            newErrors.test = 'Please select test';
                          }
                          setErrors(newErrors);
                        }}
                      >
                        {Tests.map((g) => (
                          <RadioLabel value={g.value} control={<Radio disabled={disabled} />} label={g.name} />
                        ))}
                      </RadioGroup>
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.test}</Typography>
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12}>
                  <Button
                    size="Medium"
                    variant="contained"
                    color="primary"
                    style={{ float: 'right', backgroundColor: '#003262' }}
                    onClick={() => {
                      if (disabled) {
                        setActiveTab(1);
                        window.scrollTo(0, 0);
                      } else if (page && page === 'bootcamp') {
                        handleBootcampSubmit();
                      } else if (!fromTutoring && !fromTestPrep) {
                        handleSignUp();
                      } else {
                        handleTutoringSubmit();
                      }
                    }}
                  >
                    {(fromTutoring || fromTestPrep || (page && page === 'bootcamp')) ? 'Submit' : 'Next'}
                  </Button>
                </Grid>
              </NewGrid>
            ) : (
              <NewGrid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>Which of the following causes interest you the most? <span style={{ color: 'red' }}>*</span></Typo>
                    <FormGroup>
                      {AreaOfInterest.map((a) => (
                        a.name === 'Other:' ? (<NewBox>
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.areaInterest)?.areaInterest.includes(a.value)}
                                onChange={(e) => {
                                  const array = [...areaOfInterest];
                                  if (e.target.checked) {
                                    array.push(e.target.value);
                                  } else {
                                    const newIndex = array.findIndex((v) => v.others);
                                    if (newIndex > -1) {
                                      array.splice(newIndex, 1);
                                    }
                                    const index = array.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      array.splice(index, 1);
                                    }
                                  }
                                  setAreaOfInterest(array);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.areaInterest);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.areaInterest = array;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.areaInterest)?.areaInterest?.length > 0) {
                                    newErrors.areaOfInterest = ''
                                  } else {
                                    newErrors.areaOfInterest = 'Please select atleast one option'
                                  }
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />
                          <TextField
                            variant="outlined"
                            type="text"
                            fullWidth
                            size="small"
                            disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f === '8')}
                            value={
                              [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.others)?.others || '' // If 'others' is not found, default to an empty string
                            }
                            onChange={(e) => {
                              const updatedDataArr = [...dataArr];
                              const participationObj = updatedDataArr.find((d) => d.areaInterest);
                              if (participationObj?.areaInterest?.includes('8')) {
                                const othersObj = participationObj.areaInterest.find((item) => item.others);
                                if (othersObj) {
                                  othersObj.others = e.target.value; // Update the "others" field with the new value
                                } else {
                                  participationObj.areaInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                }
                              }
                              const newErrors = errors;
                              if (e.target.value) {
                                newErrors.areaOfInterest = ''
                              } else {
                                newErrors.areaOfInterest = 'Please enter specific cause interest'
                              }
                              setErrors(newErrors);
                              setDataArr(updatedDataArr);
                            }}
                          />
                        </NewBox>) : (
                          <>
                            <RadioLabel
                              value={a.value}
                              control={
                                <Checkbox
                                  disabled={disabled}
                                  checked={[...dataArr].find((d) => d.areaInterest)?.areaInterest.includes(a.value)}
                                  onChange={(e) => {
                                    const array = [...areaOfInterest];
                                    if (e.target.checked) {
                                      array.push(e.target.value);
                                    } else {
                                      const index = array.findIndex((a) => a === e.target.value);
                                      if (index > -1) {
                                        array.splice(index, 1);
                                      }
                                    }
                                    setAreaOfInterest(array);
                                    const data = [...dataArr];
                                    const obj = {};
                                    const index = data.findIndex((d) => d.areaInterest);
                                    if (index > -1) {
                                      data.splice(index, 1);
                                    }
                                    obj.areaInterest = array;
                                    data.push(obj);
                                    const newErrors = errors;
                                    if (data?.find((d) => d.areaInterest)?.areaInterest?.length > 0) {
                                      newErrors.areaOfInterest = ''
                                    } else {
                                      newErrors.areaOfInterest = 'Please select atleast one option'
                                    }
                                    setErrors(newErrors);
                                    setDataArr(data);
                                  }}
                                />
                              }
                              label={a.name} />
                            <>
                              {(areaOfInterest.find((i) => i === '1') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('1')) && a.value === '1' && socialOptions.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...social];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setSocial(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.socialInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.socialInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest?.length > 0) {
                                                newErrors.socialInterest = ''
                                              } else {
                                                newErrors.socialInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.socialInterest)?.socialInterest.find((s) => s === '6')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.socialInterest)?.socialInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.socialInterest);
                                          if (participationObj?.socialInterest?.includes('6')) {
                                            const othersObj = participationObj.socialInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.socialInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.socialInterest = ''
                                          } else {
                                            newErrors.socialInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.socialInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...social];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setSocial(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.socialInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.socialInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.socialInterest)?.socialInterest?.length > 0) {
                                            newErrors.socialInterest = ''
                                          } else {
                                            newErrors.socialInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                              {(areaOfInterest.find((i) => i === '2') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('2')) && a.value === '2' && Climates.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...climate];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setClimate(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.climateInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.climateInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest?.length > 0) {
                                                newErrors.climateInterest = ''
                                              } else {
                                                newErrors.climateInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.climateInterest)?.climateInterest.find((s) => s === '6')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.climateInterest)?.climateInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.climateInterest);
                                          if (participationObj?.climateInterest?.includes('6')) {
                                            const othersObj = participationObj.climateInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.climateInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.climateInterest = ''
                                          } else {
                                            newErrors.climateInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.climateInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...climate];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setClimate(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.climateInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.climateInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.climateInterest)?.climateInterest?.length > 0) {
                                            newErrors.climateInterest = ''
                                          } else {
                                            newErrors.climateInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                              {(areaOfInterest.find((i) => i === '3') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('3')) && a.value === '3' && Political.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...political];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setPolitical(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.politicalInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.politicalInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest?.length > 0) {
                                                newErrors.politicalInterest = ''
                                              } else {
                                                newErrors.politicalInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.politicalInterest)?.politicalInterest.find((s) => s === '6')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.politicalInterest)?.politicalInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.politicalInterest);
                                          if (participationObj?.politicalInterest?.includes('6')) {
                                            const othersObj = participationObj.politicalInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.politicalInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.politicalInterest = ''
                                          } else {
                                            newErrors.politicalInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.politicalInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...political];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setPolitical(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.politicalInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.politicalInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.politicalInterest)?.politicalInterest?.length > 0) {
                                            newErrors.politicalInterest = ''
                                          } else {
                                            newErrors.politicalInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                              {(areaOfInterest.find((i) => i === '5') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('5')) && a.value === '5' && Health.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...health];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setHealth(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.heathInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.heathInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest?.length > 0) {
                                                newErrors.heathInterest = ''
                                              } else {
                                                newErrors.heathInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.heathInterest)?.heathInterest.find((s) => s === '5')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.heathInterest)?.heathInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.heathInterest);
                                          if (participationObj?.heathInterest?.includes('5')) {
                                            const othersObj = participationObj.heathInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.heathInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.heathInterest = ''
                                          } else {
                                            newErrors.heathInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.heathInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...health];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setHealth(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.heathInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.heathInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.heathInterest)?.heathInterest?.length > 0) {
                                            newErrors.heathInterest = ''
                                          } else {
                                            newErrors.heathInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                              {(areaOfInterest.find((i) => i === '6') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('6')) && a.value === '6' && Technology.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...technology];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setTechnology(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.techInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.techInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest?.length > 0) {
                                                newErrors.techInterest = ''
                                              } else {
                                                newErrors.techInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.techInterest)?.techInterest.find((s) => s === '6')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.techInterest)?.techInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.techInterest);
                                          if (participationObj?.techInterest?.includes('6')) {
                                            const othersObj = participationObj.techInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.techInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.techInterest = ''
                                          } else {
                                            newErrors.techInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.techInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...technology];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setTechnology(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.techInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.techInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.techInterest)?.techInterest?.length > 0) {
                                            newErrors.techInterest = ''
                                          } else {
                                            newErrors.techInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                              {(areaOfInterest.find((i) => i === '7') || [...dataArr].find((d) => d.areaInterest)?.areaInterest.includes('7')) && a.value === '7' && Education.map((a) => (
                                a.name === 'Other:' ? (
                                  <>
                                    <NewBox>
                                      <RadioLabel
                                        style={{ marginLeft: 20 }}
                                        value={a.value}
                                        control={
                                          <Checkbox
                                            disabled={disabled}
                                            checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest.includes(a.value)}
                                            onChange={(e) => {
                                              const array = [...education];
                                              if (e.target.checked) {
                                                array.push(e.target.value);
                                              } else {
                                                const newIndex = array.findIndex((v) => v.others);
                                                if (newIndex > -1) {
                                                  array.splice(newIndex, 1);
                                                }
                                                const index = array.findIndex((a) => a === e.target.value);
                                                if (index > -1) {
                                                  array.splice(index, 1);
                                                }
                                              }
                                              setEducation(array);
                                              const data = [...dataArr];
                                              const obj = {};
                                              const areaInterest = data?.find((d) => d.areaInterest);
                                              const index = areaInterest?.areaInterest?.findIndex((d) => d.eduInterest);
                                              if (index > -1) {
                                                areaInterest?.areaInterest.splice(index, 1);
                                              }
                                              obj.eduInterest = array;
                                              areaInterest?.areaInterest?.push(obj);
                                              const newErrors = errors;
                                              if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest?.length > 0) {
                                                newErrors.eduInterest = ''
                                              } else {
                                                newErrors.eduInterest = 'Please select atleast one option'
                                              }
                                              setErrors(newErrors);
                                              setDataArr(data);
                                            }}
                                          />}
                                        label={a.name}
                                      />
                                      <TextField
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        disabled={disabled || ![...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.eduInterest)?.eduInterest.find((s) => s === '5')}
                                        value={
                                          [...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.eduInterest)?.eduInterest.find((s) => s.others)?.others || '' // If 'others' is not found, default to an empty string
                                        }
                                        onChange={(e) => {
                                          const updatedDataArr = [...dataArr];
                                          const participationObj = updatedDataArr?.find((d) => d.areaInterest)?.areaInterest.find((f) => f.eduInterest);
                                          if (participationObj?.eduInterest?.includes('5')) {
                                            const othersObj = participationObj.eduInterest.find((item) => item.others);
                                            if (othersObj) {
                                              othersObj.others = e.target.value; // Update the "others" field with the new value
                                            } else {
                                              participationObj.eduInterest.push({ others: e.target.value }); // If no "others" field, create a new one
                                            }
                                          }
                                          const newErrors = errors;
                                          if (e.target.value) {
                                            newErrors.eduInterest = ''
                                          } else {
                                            newErrors.eduInterest = 'Please enter specific text'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(updatedDataArr);
                                        }}
                                      />
                                    </NewBox>
                                    <Typography variant='body2' style={{ color: 'red', marginLeft: 30 }}>{errors.eduInterest}</Typography>
                                  </>) : (
                                  <RadioLabel
                                    style={{ marginLeft: 20 }}
                                    value={a.value}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={[...dataArr]?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest.includes(a.value)}
                                        onChange={(e) => {
                                          const array = [...education];
                                          if (e.target.checked) {
                                            array.push(e.target.value);
                                          } else {
                                            const index = array.findIndex((a) => a === e.target.value);
                                            if (index > -1) {
                                              array.splice(index, 1);
                                            }
                                          }
                                          setEducation(array);
                                          const data = [...dataArr];
                                          const obj = {};
                                          const areaInterest = data?.find((d) => d.areaInterest);
                                          const index = areaInterest?.areaInterest?.findIndex((d) => d.eduInterest);
                                          if (index > -1) {
                                            areaInterest?.areaInterest.splice(index, 1);
                                          }
                                          obj.eduInterest = array;
                                          areaInterest?.areaInterest?.push(obj);
                                          const newErrors = errors;
                                          if (data?.find((d) => d.areaInterest)?.areaInterest.find((a) => a.eduInterest)?.eduInterest?.length > 0) {
                                            newErrors.eduInterest = ''
                                          } else {
                                            newErrors.eduInterest = 'Please select atleast one option'
                                          }
                                          setErrors(newErrors);
                                          setDataArr(data);
                                        }}
                                      />}
                                    label={a.name} />
                                )
                              ))}
                            </>
                          </>
                        )
                      )
                      )}
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.areaOfInterest}</Typography>
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>Please select the type of project you would be most interested in working on. You can select more than one option. <span style={{ color: 'red' }}>*</span></Typo>
                    <FormGroup>
                      {ProjectTypes.map((a) => (
                        a.name === 'Other:' ? (<NewBox>
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.projecttype)?.projecttype.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...projectType];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const newIndex = values.findIndex((v) => v.others);
                                    if (newIndex > -1) {
                                      values.splice(newIndex, 1);
                                    }
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setProjectType(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.projecttype);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.projecttype = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.projecttype)?.projecttype?.length > 0) {
                                    newErrors.projecttype = ''
                                  } else {
                                    newErrors.projecttype = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />
                          <TextField
                            variant="outlined"
                            type="text"
                            fullWidth
                            size="small"
                            disabled={disabled || ![...dataArr]?.find((d) => d.projecttype)?.projecttype.find((f) => f === '11')}
                            value={
                              [...dataArr]?.find((d) => d.projecttype)?.projecttype.find((f) => f.others)?.others || '' // If 'others' is not found, default to an empty string
                            }
                            onChange={(e) => {
                              const updatedDataArr = [...dataArr];
                              const participationObj = updatedDataArr.find((d) => d.projecttype);
                              if (participationObj?.projecttype?.includes('11')) {
                                const othersObj = participationObj.projecttype.find((item) => item.others);
                                if (othersObj) {
                                  othersObj.others = e.target.value; // Update the "others" field with the new value
                                } else {
                                  participationObj.projecttype.push({ others: e.target.value }); // If no "others" field, create a new one
                                }
                              }
                              const newErrors = errors;
                              if (e.target.value) {
                                newErrors.projecttype = ''
                              } else {
                                newErrors.projecttype = 'Please enter specific type of project'
                              }
                              setErrors(newErrors);
                              setDataArr(updatedDataArr);
                            }}
                          />
                        </NewBox>) : (
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.projecttype)?.projecttype.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...projectType];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setProjectType(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.projecttype);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.projecttype = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.projecttype)?.projecttype?.length > 0) {
                                    newErrors.projecttype = ''
                                  } else {
                                    newErrors.projecttype = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />)
                      )
                      )}
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.projecttype}</Typography>
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>What type of support are you looking for in working on your project? Please select all that apply. <span style={{ color: 'red' }}>*</span></Typo>
                    <FormGroup>
                      {SupportTypes.map((a) => (
                        a.name === 'Other:' ? (<NewBox>
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.supporttype)?.supporttype.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...supportType];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const newIndex = values.findIndex((v) => v.others);
                                    if (newIndex > -1) {
                                      values.splice(newIndex, 1);
                                    }
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setSupportType(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.supporttype);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.supporttype = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.supporttype)?.supporttype?.length > 0) {
                                    newErrors.supporttype = ''
                                  } else {
                                    newErrors.supporttype = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />
                          <TextField
                            variant="outlined"
                            type="text"
                            fullWidth
                            size="small"
                            disabled={disabled || ![...dataArr]?.find((d) => d.supporttype)?.supporttype.find((f) => f === '7')}
                            value={
                              [...dataArr]?.find((d) => d.supporttype)?.supporttype.find((f) => f.others)?.others || '' // If 'others' is not found, default to an empty string
                            }
                            onChange={(e) => {
                              const updatedDataArr = [...dataArr];
                              const participationObj = updatedDataArr.find((d) => d.supporttype);
                              if (participationObj?.supporttype?.includes('7')) {
                                const othersObj = participationObj.supporttype.find((item) => item.others);
                                if (othersObj) {
                                  othersObj.others = e.target.value; // Update the "others" field with the new value
                                } else {
                                  participationObj.supporttype.push({ others: e.target.value }); // If no "others" field, create a new one
                                }
                              }
                              const newErrors = errors;
                              if (e.target.value) {
                                newErrors.supporttype = ''
                              } else {
                                newErrors.supporttype = 'Please enter specific type of support'
                              }
                              setErrors(newErrors);
                              setDataArr(updatedDataArr);
                            }}
                          />
                        </NewBox>) : (
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.supporttype)?.supporttype.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...supportType];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setSupportType(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.supporttype);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.supporttype = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.supporttype)?.supporttype?.length > 0) {
                                    newErrors.supporttype = ''
                                  } else {
                                    newErrors.supporttype = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />)
                      )
                      )}
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.supporttype}</Typography>
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>Please select the skill level that best describes your proficiency in the area related to your selected project type(s)</Typo>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={[...dataArr].find((d) => d.skills)?.skills}
                    onChange={(e) => {
                      const data = [...dataArr];
                      const obj = {};
                      const index = data.findIndex((d) => d.skills);
                      if (index > -1) {
                        data.splice(index, 1);
                      }
                      obj.skills = e.target.value;
                      data.push(obj);
                      setDataArr(data);
                    }}
                  >
                    {Skills.map((s) => (
                      <RadioLabel value={s.value} control={<Radio disabled={disabled} />} label={s.name} />
                    ))}
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>How many hours per week would you be willing to dedicate to your project? <span style={{ color: 'red' }}>*</span></Typo>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={[...dataArr].find((d) => d.workinghour)?.workinghour}
                      onChange={(e) => {
                        const newErrors = errors;
                        if (e.target.checked) {
                          newErrors.workinghour = ''
                        } else {
                          newErrors.workinghour = 'Please select option'
                        }
                        setErrors(newErrors);
                        const data = [...dataArr];
                        const obj = {};
                        const index = data.findIndex((d) => d.workinghour);
                        if (index > -1) {
                          data.splice(index, 1);
                        }
                        obj.workinghour = e.target.value;
                        data.push(obj);
                        setDataArr(data);
                      }}
                    >
                      {WorkingHours.map((s) => (
                        <RadioLabel value={s.value} control={<Radio disabled={disabled} />} label={s.name} />
                      ))}
                    </RadioGroup>
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.workinghour}</Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>How do you prefer to learn when working on projects? <span style={{ color: 'red' }}>*</span></Typo>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={[...dataArr].find((d) => d.learning)?.learning}
                      onChange={(e) => {
                        const newErrors = errors;
                        if (e.target.checked) {
                          newErrors.learning = ''
                        } else {
                          newErrors.learning = 'Please select option'
                        }
                        setErrors(newErrors);
                        const data = [...dataArr];
                        const obj = {};
                        const index = data.findIndex((d) => d.learning);
                        if (index > -1) {
                          data.splice(index, 1);
                        }
                        obj.learning = e.target.value;
                        data.push(obj);
                        setDataArr(data);
                      }}
                    >
                      {LearningTech.map((s) => (
                        <RadioLabel value={s.value} control={<Radio disabled={disabled} />} label={s.name} />
                      ))}
                    </RadioGroup>
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.learning}</Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>Have you worked on any team projects before (in school or outside school)? If so, what role do you typically take in the group? <span style={{ color: 'red' }}>*</span></Typo>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={[...dataArr].find((d) => d.teamWork)?.teamWork}
                      onChange={(e) => {
                        const data = [...dataArr];
                        const newErrors = errors;
                        if (e.target.checked) {
                          newErrors.teamWork = ''
                        } else {
                          newErrors.teamWork = 'Please select option'
                        }
                        setErrors(newErrors);
                        const obj = {};
                        const index = data.findIndex((d) => d.teamWork);
                        if (index > -1) {
                          data.splice(index, 1);
                        }
                        obj.teamWork = e.target.value;
                        data.push(obj);
                        setDataArr(data);
                      }}
                    >
                      {TeamWork.map((s) => (
                        <RadioLabel value={s.value} control={<Radio disabled={disabled} />} label={s.name} />
                      ))}
                    </RadioGroup>
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.teamWork}</Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typo variant='body1'>How do you see your participation in this project influencing your college applications and career plans? (Select all that apply) <span style={{ color: 'red' }}>*</span></Typo>
                    <FormGroup>
                      {Participations.map((a) => (
                        a.name === 'Other:' ? (<NewBox>
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.participation)?.participation.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...participation];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const newIndex = values.findIndex((v) => v.others);
                                    if (newIndex > -1) {
                                      values.splice(newIndex, 1);
                                    }
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setParticipation(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.participation);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.participation = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.participation)?.participation?.length > 0) {
                                    newErrors.participation = ''
                                  } else {
                                    newErrors.participation = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />
                          <TextField
                            variant="outlined"
                            type="text"
                            fullWidth
                            size="small"
                            disabled={disabled || ![...dataArr]?.find((d) => d.participation)?.participation.find((f) => f === '6')}
                            value={
                              [...dataArr]?.find((d) => d.participation)?.participation.find((f) => f.others)?.others || '' // If 'others' is not found, default to an empty string
                            }
                            onChange={(e) => {
                              const updatedDataArr = [...dataArr];
                              const participationObj = updatedDataArr.find((d) => d.participation);
                              if (participationObj?.participation?.includes('6')) {
                                const othersObj = participationObj.participation.find((item) => item.others);
                                if (othersObj) {
                                  othersObj.others = e.target.value; // Update the "others" field with the new value
                                } else {
                                  participationObj.participation.push({ others: e.target.value }); // If no "others" field, create a new one
                                }
                              }
                              const newErrors = errors;
                              if (e.target.value) {
                                newErrors.participation = ''
                              } else {
                                newErrors.participation = 'Please enter specific text'
                              }
                              setDataArr(updatedDataArr);
                            }}
                          />
                        </NewBox>) : (
                          <RadioLabel
                            value={a.value}
                            control={
                              <Checkbox
                                disabled={disabled}
                                checked={[...dataArr].find((d) => d.participation)?.participation.includes(a.value)}
                                onChange={(e) => {
                                  const values = [...participation];
                                  if (e.target.checked) {
                                    values.push(e.target.value);
                                  } else {
                                    const index = values.findIndex((v) => v === e.target.value);
                                    if (index > -1) {
                                      values.splice(index, 1);
                                    }
                                  }
                                  setParticipation(values);
                                  const data = [...dataArr];
                                  const obj = {};
                                  const index = data.findIndex((d) => d.participation);
                                  if (index > -1) {
                                    data.splice(index, 1);
                                  }
                                  obj.participation = values;
                                  data.push(obj);
                                  const newErrors = errors;
                                  if (data?.find((d) => d.participation)?.participation?.length > 0) {
                                    newErrors.participation = ''
                                  } else {
                                    newErrors.participation = 'Please select atleast one option'
                                  }
                                  setErrors(newErrors);
                                  setDataArr(data);
                                }}
                              />}
                            label={a.name}
                          />)
                      )
                      )}
                      <Typography variant='body2' style={{ color: 'red' }}>{errors.participation}</Typography>
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Typo variant='body1'>Do you have a project topic that you have already decided? If YES, provide details</Typo>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    multiline
                    minRows={5}
                    disabled={disabled}
                    value={[...dataArr].find((d) => d.projecttopic)?.projecttopic}
                    onChange={(e) => {
                      const data = [...dataArr];
                      const obj = {};
                      const index = data.findIndex((d) => d.projecttopic);
                      if (index > -1) {
                        data.splice(index, 1);
                      }
                      obj.projecttopic = e.target.value;
                      data.push(obj);
                      setDataArr(data);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  {!disabled && (
                    <Button
                      size="Medium"
                      variant="contained"
                      color="primary"
                      style={{ float: 'right', backgroundColor: '#003262' }}
                      onClick={() => {
                        updateSignUp()
                      }}
                    >
                      Submit
                    </Button>
                  )}
                  {id && disabled && (
                    <>
                      <Button
                        size="Medium"
                        variant="contained"
                        color="primary"
                        style={{ float: 'right', width: 135, marginRight: 10, backgroundColor: '#003262' }}
                        onClick={() => {
                          window.open("https://calendly.com/dreamcollegepath/30min", "_blank");
                        }}
                      >
                        Book A Demo
                      </Button>
                      <Button
                        size="Medium"
                        variant="contained"
                        color="primary"
                        style={{ float: 'right', marginRight: 10, backgroundColor: '#003262' }}
                        onClick={() => {
                          setActiveTab(0);
                          window.scrollTo(0, 0);
                        }}
                      >
                        Previous
                      </Button>
                    </>
                  )}
                </Grid>
              </NewGrid>)
          }

        </section>
        {!page && page !== 'bootcamp' && (
          <section className='img_section'>
            {fromTestPrep ?
              <img className='ad-img' src="/images/dcp_test_dates.png" alt="UC Berkeley Logo" />

              : fromTutoring ?
                <img className='ad-img' src="/images/3.jpg" alt="UC Berkeley Logo" />
                :

                <img className='ad-img' src="/images/1.jpg" alt="UC Berkeley Logo" />
            }
          </section>
        )}
      </div>
    </>
  );
};

export default SignUp;
